import {createContext} from "react";
import MediaLibraryDataStore from "./MediaLibraryDataStore";

const MediaLibraryContext = createContext<MediaLibraryDataStore|undefined>(undefined);
MediaLibraryContext.displayName = 'MediaLibraryContext';

export default MediaLibraryContext
